module.exports = __webpack_public_path__ + "img/yellow-booth-table-6.d4d8f844.png";